module.exports = __webpack_public_path__ + "img/ic_flag_england.b7a24dd4.svg";